import { action, makeObservable, observable } from 'mobx';

import { assignModel } from '@/common/helpers/assignModel';
import { ensureExternalUrlProtocol } from '@/common/helpers/ensureExternalUrlProtocol';
import { DriveItemPreview } from '@/drive/entities/DriveItem/DriveItemPreview';
import { DriveItemId } from '@/drive/entities/DriveItemId';
import { PinnedItem } from '@/forwarding/entities/PinnedItem/PinnedItem';
import { PinnedUrl } from '@/forwarding/entities/PinnedItem/PinnedUrl';
import { ForwardForm } from '@/forwarding/types/ForwardForm';

import { BaseDriveItem, DriveItemType } from './DriveItem.types';

export class UrlItemModel {
  id!: DriveItemId;
  title!: string;
  type!: DriveItemType.Url;
  description?: string;
  preview?: Nullable<DriveItemPreview>;
  canEdit!: boolean;
  canManageAccess!: boolean;
  url!: string;
}

export class UrlItem extends BaseDriveItem {
  url!: string;

  constructor(model: UrlItemModel) {
    super();

    makeObservable(this, {
      url: observable,
      setUrl: action,
    });

    assignModel<UrlItemModel>(this as unknown as UrlItemModel, model);
  }

  getLinkData() {
    return {
      isExternal: true,
      url: ensureExternalUrlProtocol(this.url),
    };
  }

  override getDisplayTitle(): string {
    return this.title || this.url || '';
  }

  override toPinnedItem(): Nullable<PinnedItem> {
    return new PinnedUrl(this);
  }

  override canChangePreview(): boolean {
    return true;
  }

  override toFormData(): ForwardForm {
    return {
      ...super.toFormData(),
      url: this.url ?? '',
    };
  }

  setUrl(url: string) {
    this.url = url;
  }
}
